module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cpo-section grid",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "cpo-section--container",
    class: _vm.containerClasses
  }, [_c('div', {
    staticClass: "grid--row cpo-section--row"
  }, [_c('div', {
    staticClass: "grid--col cpo-section--title-col"
  }, [(_vm.content.title) ? _c('div', {
    staticClass: "cpo-section--title-root"
  }, [_c('h2', {
    staticClass: "u-reset cpo-section--title",
    domProps: {
      "textContent": _vm._s(_vm.content.title)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grid--col cpo-section--content-col"
  }, [_c('ul', {
    staticClass: "u-reset cpo-section--items"
  }, _vm._l((_vm.content.items), function(item, itemIdx) {
    return _c('li', {
      staticClass: "cpo-section--item"
    }, [_c('cmp-cpo-event', {
      attrs: {
        "plugin": item,
        "facet": item.content && item.content.facet,
        "color-facet": _vm.eventFacet,
        "is-global-first": _vm.isFirst,
        "is-global-last": _vm.isLast,
        "is-first": itemIdx === 0,
        "is-last": itemIdx === _vm.content.items.length - 1,
        "is-light": _vm.isLight,
        "is-dark": _vm.isDark
      }
    })], 1)
  }))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47ac4f98", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47ac4f98","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/course-progress/cpo-section/index.vue
// module id = 540
// module chunks = 7